import { Component, Input, OnInit } from '@angular/core';
import { AccountService } from '../../../User/account.service';
import { ApplicationPermissionService } from '../applicationPermission.service';

import * as _ from 'lodash';

@Component({
    selector: 'user-application-permission-panel',
    templateUrl: './userApplicationPermissionPanel.component.html',
    standalone: false
})
export class UserApplicationPermissionPanelComponent implements OnInit {
    constructor(private _applicationPermissionService: ApplicationPermissionService,
                private _accountService: AccountService) {
    }

    @Input() editMode: boolean;
    @Input() assignedPermissions;
    @Input() userSetup: boolean;

    availablePermissions = [];
    permissionToAdd = null;
    uniqueScreenTypes = [];
    screenTypePermissions = [];
    permissionLookup = [];

    usablePermission = (permission) => {
        const roleHasAlreadyAssigned = !this.assignedPermissions.some(x => x.screenTypeID === permission.screenTypeID);

        const userGlobalRoles = this._accountService.userData.globalRoles;
        const rolesWithSameScreenType = this.availablePermissions.filter(ap => ap.screenTypeID == permission.screenTypeID);
        const userHasRoleWithScreenType = userGlobalRoles.some(r => rolesWithSameScreenType.some(s => s.name === r));

        return roleHasAlreadyAssigned && userHasRoleWithScreenType;
    }

    async ngOnInit() {
        this.availablePermissions = await this._applicationPermissionService.get();
        this.permissionLookup = structuredClone(this.availablePermissions);

        this.uniqueScreenTypes = _.uniqBy(this.availablePermissions, 'screenTypeID');
    }

    selectPermissionToAdd() {
        this.permissionToAdd = {};
    }

    cancelAddPermission() {
        this.permissionToAdd = null;
    }

    addPermission() {
        this.permissionToAdd.permission.screenTypeID = this.permissionToAdd.screenTypeID;
        this.permissionToAdd.permission.screenType = this.permissionToAdd.permission.screenType || this._getScreenType(this.permissionToAdd.screenTypeID);

        this.assignedPermissions.push(this.permissionToAdd.permission);

        this.cancelAddPermission();
    }

    screenTypeSelected(id: number) {
        this.permissionToAdd.screenTypeID = id;
        this.screenTypePermissions = this.availablePermissionRights(this.permissionToAdd.screenTypeID);

        this.permissionToAdd.permission = _.minBy(this.screenTypePermissions, 'rightsID');
    }

    availablePermissionRights(id: number) {
        if (this.availablePermissions.length === 0) {
            return;
        }

        return this.availablePermissions
            .filter((ap) => {
                return ap.screenTypeID == id && this._accountService.userData.globalRoles.includes(ap.name);
            })
            .sort((a, b) => a.rightsID - b.rightsID);
    }

    deletePermission(permission) {
        _.remove(this.assignedPermissions, permission);
    }

    getPermissionLabel(roleID) {
        const permission = this.permissionLookup.find(x => x.roleID === roleID);

        return permission ? permission.rights : '';
    }

    userHasGlobalRole(permission) {
        const globalRoles = this._accountService.userData.globalRoles;
        return globalRoles.includes(permission.name);
    }

    private _getScreenType(id: number) {
        return this.availablePermissions.find(x => x.screenTypeID === id).screenType;
    }
}
